import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ApproachPage from "@/pages/ApproachPage";
import CapabilitiesPage from "@/pages/CapabilitiesPage";
import ExperiencePage from "@/pages/ExperiencePage";
import InsightsPage from "@/pages/InsightsPage";
import ArticlePage from "@/pages/ArticlePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import StyleBPage from "@/pages/StyleBPage";
import { StyleBContext } from "@/theme/styleb-context";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const [sbTheme, setSbTheme] = useState("dark");
  const isStyleB = pathname === "/" || pathname === "/styleb";

  return (
    <StyleBContext.Provider
      value={{
        theme: sbTheme,
        toggle: () => setSbTheme((t) => (t === "dark" ? "light" : "dark")),
      }}
    >
      <div
        className={`min-h-screen bg-canvas text-ink font-sans${
          isStyleB ? ` styleb sb-${sbTheme}` : ""
        }`}
      >
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<StyleBPage />} />
            <Route path="/stylea" element={<HomePage />} />
            <Route path="/styleb" element={<StyleBPage />} />
            <Route path="/approach" element={<ApproachPage />} />
            <Route path="/capabilities" element={<CapabilitiesPage />} />
            <Route path="/experience" element={<ExperiencePage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:slug" element={<ArticlePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </StyleBContext.Provider>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
